import styled from 'styled-components'
import propTypes from 'prop-types'
import { ChangeEventHandler, KeyboardEventHandler } from 'react'

const StyledInput = styled.input`
  &:focus {
    outline: none;
  }
`

const StyledFormGroup = styled.div`
  label {
    font-size: 13px;
    position: relative;
    color: #707070;
    span {
      font-size: 2rem;
      color: orangered;
      padding-left: 2px;
      position: absolute;
      transform: translate(1px, 3px);
    }
  }
`

type TBInputProps = Partial<HTMLInputElement> & {
  label?: string
  handleChange?: ChangeEventHandler<HTMLInputElement>
  onKeyDown?: KeyboardEventHandler<HTMLInputElement>
}

const TBInput = ({
  type = 'text',
  label = '',
  id,
  value,
  name = 'name',
  placeholder = '',
  className = '',
  required = false,
  handleChange,
  onKeyDown,
}: TBInputProps) => {
  return (
    <StyledFormGroup className={`tb-input ${className}`}>
      <label className={'label'}>
        {label}
        {required && <span>*</span>}
        <StyledInput
          className={'tb-inside-input'}
          type={type}
          value={value}
          name={name}
          placeholder={placeholder}
          onChange={handleChange}
          onKeyDown={onKeyDown}
          id={id}
        />
      </label>
    </StyledFormGroup>
  )
}

TBInput.propTypes = {
  type: propTypes.string,
  label: propTypes.string,
  id: propTypes.string,
  value: propTypes.string,
  placeholder: propTypes.string,
  handleChange: propTypes.func,
  onKeydown: propTypes.func,
}

export default TBInput
